import type { PromotionModeration } from '../model/schema';

// The status a promotion row shows.
//
// A row WITH a moderation verdict (the joined `by-merchant` rows) shows the
// verdict; a row WITHOUT one (bare `by-restaurant` rows, or `UNSPECIFIED`)
// falls back to the legacy active/inactive label from `is_active`. The tone
// keys double as the `promotions.status.*` locale suffixes.
export type PromotionStatusTone = PromotionModeration | 'active' | 'inactive';

export function promotionStatusTone(promotion: {
  moderationState?: PromotionModeration | undefined;
  isActive?: boolean | undefined;
}): PromotionStatusTone {
  switch (promotion.moderationState) {
    case 'approved':
    case 'pending':
    case 'rejected':
    case 'draft':
      return promotion.moderationState;
    default:
      return (promotion.isActive ?? true) ? 'active' : 'inactive';
  }
}
